export default __webpack_public_path__ + "static/media/audience-trend.png";